import BatteryStateSnackbars from './BatteryStateSnackbars';
import CollaboratorSyncErrorSnackbar from './CollaboratorSyncErrorSnackbar';
import DrivingDisabledWarningSnackbar from './DrivingDisabledWarningSnackbar';
import PathMetadataOmittedSnackbar from './PathMetadataOmittedSnackbar';
import PersistMigrationWarningSnackbar from './PersistMigrationWarningSnackbar';
import PwaUpdateSnackbar from './PwaUpdateSnackbar';
import ResetOrientationAcknowledgementSnackbar from './ResetOrientationAcknowledgementSnackbar';
import ViewerReadOnlyModeSnackbar from './ViewerReadOnlyModeSnackbar';

const AppSnackbars = () => (
  <>
    <PwaUpdateSnackbar />
    <DrivingDisabledWarningSnackbar />
    <BatteryStateSnackbars />
    <PersistMigrationWarningSnackbar />
    <CollaboratorSyncErrorSnackbar />
    <ViewerReadOnlyModeSnackbar />
    <ResetOrientationAcknowledgementSnackbar />
    <PathMetadataOmittedSnackbar />
  </>
);

export default AppSnackbars;
